import { Component, OnInit } from '@angular/core';
import { OrderTermsJeevesComponent } from 'gung-standard-jeeves';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  AuthService,
  PriceService,
  // CustomerProductPrice,
  AvailabilityService,
  MetadataService,
  SelectedCustomerService
} from 'gung-standard';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs';

interface Alert {
  type: string;
  message: string;
}

@Component({
    selector: 'colmec-checkout-step-order-terms',
    templateUrl: './colmec-checkout-step-order-terms.component.html',
    styleUrls: ['./colmec-checkout-step-order-terms.component.scss'],
    standalone: false
})
export class ColmecCheckoutStepOrderTermsComponent extends OrderTermsJeevesComponent implements OnInit {
  // private expressFreightProductId = '26575';
  deliveryOptions = [];
  selectedLevsattkod: string;
  alertMessage: Alert;
  // public _colmecHasSpikesOrSipingOrAssembly: boolean;
  // expressFreightCustomerProductPrice: CustomerProductPrice;

  //                                                 Bring, DHL, DSV Schenker, Avhämtas
  protected static readonly EXTRA_DELIVERY_METHODS = ['2', '3', '4', '9'];

  constructor(
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected datePipe: DatePipe,
    protected priceService: PriceService,
    protected availabilityService: AvailabilityService,
    protected metadataService: MetadataService,
    protected selectedCustomerService: SelectedCustomerService
  ) {
    super(authService, formBuilder, datePipe, availabilityService);
  }

  ngOnInit() {
    super.ngOnInit();

    // this._colmecHasSpikesOrSipingOrAssembly = false;
    // this.checkout.rows.forEach(row => {
    //   this._colmecHasSpikesOrSipingOrAssembly =
    //     this._colmecHasSpikesOrSipingOrAssembly ||
    //     row.extra._colmecDubbingSelected ||
    //     row.extra._colmecSipingSelected ||
    //     !!(row.extra.configure && row.extra.configure.assembly);
    // });

    // this.priceService
    //   .getCustomerPrice(this.expressFreightProductId, this.checkout.billingCustomerId)
    //   .pipe(first())
    //   .subscribe(customerProductPrice => {
    //     this.expressFreightCustomerProductPrice = customerProductPrice;
    //   });

    this.onNextBtnClicked.subscribe(_ => this.handleNextButtonClicked2());
  }

  private handleNextButtonClicked2(): void {
    if (this.form.invalid) {
      if (this.form.get('ordberlevdat').invalid) {
        this.alertMessage = {
          type: 'danger',
          message: 'DELIVERY_DATE_REQUIRED'
        };
      } else {
        this.alertMessage = null;
      }
      return;
    }

    this.assignFormValues(this.form);
    this.stepDone.emit(this.checkout);
  }

  protected initForm() {
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(customer => {
        let customerDeliveryValue = {
          id: customer.extra.kus.levsattkod,
          value: this.metadataService.getMetadataValue('x2f', 'levsattbeskr', customer.extra.kus.levsattkod)
        };
        if (this.checkout.extra.customerMethodCode) {
          customerDeliveryValue = {
            id: this.checkout.extra.customerMethodCode,
            value: this.metadataService.getMetadataValue('x2f', 'levsattbeskr', this.checkout.extra.customerMethodCode)
          };
          delete this.checkout.extra.customerMethodCode;
        }
        this.form = this.formBuilder.group({
          // _colmecExpressDelivery: this.formBuilder.control(this.checkout.extra._colmecExpressDelivery || false),
          levsattkod: [{ disabled: false, value: customerDeliveryValue.id || '' }],
          levvillkkod: [{ disabled: true, value: this.checkout.extra.procargs.levvillkkod || '' }],
          betkod: [{ disabled: true, value: this.checkout.extra.oh.betkod || '' }],
          saljare: [{ disabled: true, value: this.checkout.extra.procargs.saljare || '' }],
          ordberlevdat: this.formBuilder.control('', [Validators.required]),
          endcustomer: this.formBuilder.control(this.checkout.extra.procargs.endcustomer || '', [])
        });

        this.selectedLevsattkod = '' + (customerDeliveryValue.id || '');
        this.form.get('levsattkod')?.valueChanges.subscribe(code => {
          this.selectedLevsattkod = '' + (code || '');
        })

        const options = [customerDeliveryValue];
        this.getExtraDeliveryMethods().forEach(code => {
          if (options.some(o => '' + o.id === code)) {
            return; // kundens eget leveranssätt är redan med
          }
          const label = this.metadataService.getMetadataValue('x2f', 'levsattbeskr', code);
          if (label) {
            options.push({ id: code, value: label });
          }
        });
        this.deliveryOptions = options;
      });
  }

  protected assignFormValues(formGroup: FormGroup) {
    const rawValues = formGroup.getRawValue();
    this.checkout.extra = {
      ...this.checkout.extra,
      // _colmecExpressDelivery: JSON.parse(rawValues._colmecExpressDelivery),
      procargs: {
        ...this.checkout.extra.procargs,
        levsattkod: rawValues.levsattkod,
        levvillkkod: rawValues.levvillkkod,
        saljare: rawValues.saljare,
        endcustomer: rawValues.endcustomer
      },
      oh: {
        ...this.checkout.extra.oh,
        betkod: rawValues.betkod
      }
    };
  }

  protected getExtraDeliveryMethods(): string[] {
    return ColmecCheckoutStepOrderTermsComponent.EXTRA_DELIVERY_METHODS;
  }

  dateSelected(event) {
    const date = event.date;
    const dString: string = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.checkout.extra.oh.ordberlevdat = dString;
    this.form.patchValue({
      ordberlevdat: dString
    });
  }
}
